import { Button, CircularProgress, Modal, Slider, TextField, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import html2canvas from "html2canvas";
import React, { useEffect, useState } from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";
import ModelRankingTable from './ModelRankingTable';


import {
  Brush,
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts";

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { format } from "date-fns";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import { useRef } from "react";
import "./leftbar.css";


const Imputlog = ({
  selectedMarker,
  setIsImModalOpen,
  setIsMultiColImModalOpen,
  HelpModal,
  imdatalogs,
  setimDatalogs,
  formatDate,
  helpOpen,
  setHelpOpen,
  handleCloseImModal,
}) => {



  const [showMinDateModal, setShowMinDateModal] = useState(false);

  const [imputationType, setImputationType] = useState('new'); // Default to 'new' imputation
  const handleImputationTypeChange = (event) => {
    setImputationType(event.target.value);
  };
  const handleSubmit = () => {
    if (imputationType === 'reuse') {
      handleReUseImputation();
    } else {
      handleDoImputation();
    }
  };





  const [zoomLevelImDatalogs, setZoomLevelImDatalogs] = useState(0);
  const [startIndexImDatalogs, setStartIndexImDatalogs] = useState(0);
  const [endIndexImDatalogs, setEndIndexImDatalogs] = useState(imdatalogs.length - 1);

  const [missingDataRate, setMissingDataRate] = useState(null);
  const [showMissingRate, setShowMissingRate] = useState(false);

  useEffect(() => {
    setStartIndexImDatalogs(0);
    setEndIndexImDatalogs(imdatalogs.length - 1);
  }, [imdatalogs]); // Ensures indices update when new data comes in



  const handleZoomImDatalogs = (event, newValue) => {
    setZoomLevelImDatalogs(newValue);
    const range = imdatalogs.length;
    const zoomFactor = newValue / 100;

    const newStart = Math.floor(range * zoomFactor * 0.5);
    const newEnd = Math.ceil(range * (1 - zoomFactor * 0.5));

    setStartIndexImDatalogs(Math.max(0, newStart));
    setEndIndexImDatalogs(Math.min(imdatalogs.length - 1, newEnd));
  };



  const handleZoomInImDatalogs = () =>
    setZoomLevelImDatalogs((prev) => Math.min(prev + 10, 100));
  const handleZoomOutImDatalogs = () =>
    setZoomLevelImDatalogs((prev) => Math.max(prev - 10, 0));
  const resetZoomImDatalogs = () => {
    setStartIndexImDatalogs(0);
    setZoomLevelImDatalogs(0);
    setEndIndexImDatalogs(imdatalogs.length - 1);
  };
  const handleSort = (key) => {
    const newDirection = sortConfig[key].direction === "asc" ? "desc" : "asc";
    setSortConfig({
      ...sortConfig,
      [key]: { direction: newDirection },
    });
  };


  const visibleDataImDatalogs = imdatalogs.slice(
    startIndexImDatalogs,
    endIndexImDatalogs + 1
  );

  const [selectedMetric, setSelectedMetric] = useState("wtr"); // Default to Water Level


  const [dataLimitImDatalogs, setDataLimitImDatalogs] = useState(
    visibleDataImDatalogs.length
  ); // Default to all data


  // Apply the data limit to the visible data
  const handleDataLimitChangeImDatalogs = (event) => {
    setDataLimitImDatalogs(parseInt(event.target.value));
  };

  // Apply the data limit to the visible data
  const filteredDataImDatalogs = visibleDataImDatalogs.slice(
    -dataLimitImDatalogs
  );


  const [sortConfig, setSortConfig] = useState({
    mTm: { direction: "asc" },
    wtr: { direction: "asc" },
    // tmp: { direction: "asc" },
    // prs: { direction: "asc" },
  });

  // State for model weights
  const [weights, setWeights] = useState({
    weight_lstm: 1,
    weight_bilstm: 1,
    weight_arima: 1,
    weight_sarima: 1,
    weight_iter: 1,
  });


  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    const newEndDate = event.target.value;

    // Only perform validation if both dates are selected
    if (startDate && newEndDate) {
      const start = new Date(startDate);
      const end = new Date(newEndDate);

      // Calculate difference in years
      const diffInMs = end - start;
      const msInYear = 1000 * 60 * 60 * 24 * 365.25; // Account for leap years
      const diffInYears = diffInMs / msInYear;

      if (diffInYears < 2) {
        // If less than 2 years, show the modal and don't update the end date
        setShowMinDateModal(true);
        return;
      }
    }

    // If validation passes or not enough info to validate, update the end date
    setEndDate(newEndDate);
  };

  const handleCloseMinDateModal = () => {
    setShowMinDateModal(false);
  };



  const [earliestDate, setEarliestDate] = useState("");
  const [latestDate, setLatestDate] = useState("");

  useEffect(() => {
    const fetchDateRange = async () => {
      try {
        const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/${selectedMarker.wellId}/date-range`);
        const data = await response.json();

        if (response.ok) {
          setEarliestDate(data.earliest);
          setLatestDate(data.latest);
        } else {
          console.error(data.message || "Failed to fetch date range.");
        }
      } catch (err) {
        console.error("Error fetching date range:", err);
      }
    };

    fetchDateRange();
  }, [selectedMarker]);

  const [versions, setVersions] = useState([]); // Store versions data from backend
  const [selectedVersion, setSelectedVersion] = useState(null); // Selected version number
  const [tableData, setTableData] = useState([]); // Store the fetched data for the selected version

  // State to store modal open state and version details
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [versionDetails, setVersionDetails] = useState(null);



  const fetchVersions = async (wellId) => {
    try {
      const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/datalogs_versions/${wellId}`);
      const data = await response.json();

      if (response.ok) {
        const impData = data.filter(item => item.imp_or_anom === 'imp');
        setVersions(impData);

        // If there are versions available, set the latest one as default
        if (impData.length > 0) {
          const latestVersion = impData[impData.length - 1].version_number;
          // console.log(latestVersion)
          setSelectedVersion(latestVersion);

          // Fetch the data for this version immediately
          fetchVersionData(wellId, latestVersion);
        }
      } else {
        console.error("Error fetching versions:", data.error);
      }
    } catch (error) {
      console.error("Error fetching versions:", error);
    }
  };

  const fetchVersionData = async (wellId, versionNumber) => {
    try {
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs_version/${wellId}/${versionNumber}`
      );
      const data = await response.json();

      if (response.ok) {
        setTableData(data);
        setimDatalogs(data);

        // Reset zoom and visualization settings when loading version data
        resetZoomImDatalogs();
        setDataLimitImDatalogs(data.length);
      } else {
        console.error("Error fetching imputed data:", data.error);
      }
    } catch (error) {
      console.error("Error fetching imputed data:", error);
    }
  };

  // Updated useEffect hook to properly initialize the data
  useEffect(() => {
    if (selectedMarker && selectedMarker.wellId) {
      fetchVersions(selectedMarker.wellId);
    }
  }, [selectedMarker]);


  const fetchVersionDetails = async () => {
    try {
      // Call the API to get the version details (here version 0 means the latest)
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/get-version-details/${selectedMarker.wellId}/${selectedVersion}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'imp_or_anom': 'imp'
          }
        }
      );
      const data = await response.json();

      if (response.ok) {
        setVersionDetails(data); // Store the received data in state
        setIsModalOpen(true); // Open the modal
      } else {
        console.error("Error fetching version details:", data.error);
      }
    } catch (error) {
      console.error("Error fetching data from backend:", error);
    }
  };

  // Handle version change in dropdown
  const handleVersionChange = async (event) => {
    const versionNumber = event.target.value;
    setSelectedVersion(versionNumber); // Update selected version number

    try {
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs_version/${selectedMarker.wellId}/${versionNumber}`
      );
      const data = await response.json();

      if (response.ok) {
        setTableData(data); // Keep this for consistency
        setimDatalogs(data); // Update the main datalogs state used by the graph and table

        // Reset zoom and visualization settings when changing versions
        resetZoomImDatalogs();
        setDataLimitImDatalogs(data.length);
      } else {
        console.error("Error fetching imputed data:", data.error);
        alert("Error fetching data for this version");
      }
    } catch (error) {
      console.error("Error fetching imputed data:", error);
      alert("Failed to fetch data for this version");
    }
  };


  const handleDetailsButtonClick = () => {
    if (selectedVersion) {
      fetchVersionDetails(selectedMarker.wellId, selectedVersion); // Fetch details for the selected version
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  // Fetch versions on component mount or when selectedMarker changes
  useEffect(() => {
    if (selectedMarker && selectedMarker.wellId) {
      fetchVersions(selectedMarker.wellId); // Fetch versions when the wellId is available
    }
  }, [selectedMarker]);



  // Custom Dot Component
  const CustomDot = (props) => {
    const { cx, cy, payload } = props;
    if (payload.is_imputed) {
      return (
        <circle cx={cx} cy={cy} r={5} stroke="red" strokeWidth={2} fill="red" />
      );
    }

    return (
      <circle
        cx={cx}
        cy={cy}
        r={5}
        fill="black"
      />
    );
  };

  // Custom Dot Component
  const CustomDotAnomaly = (props) => {
    const { cx, cy, payload } = props;
    if (payload.is_anomaly_corrected === 1) {
      return (
        <circle
          cx={cx}
          cy={cy}
          r={5}
          stroke="orange"
          strokeWidth={2}
          fill="orange"
        />
      );
    }

    return (
      <circle
        cx={cx}
        cy={cy}
        r={5}
        stroke="black"
        strokeWidth={2}
        fill="blue"
      />
    );
  };

  const handleWeightChange = (event) => {
    const { name, value } = event.target;
    if (isNaN(value)) {
      alert("Please enter a numerical value");
      return;
    }
    setWeights((prevWeights) => ({
      ...prevWeights,
      [name]: value,
    }));
  };

  const [progress, setProgress] = useState(0);

  const [Rate, setRate] = useState("");
  const handleRateChange = (event) => {
    setRate(event.target.value);
  };

  const [option, setOption] = useState("overall"); // Initialize with the string "overall"

  const handleOption = (event, newOption) => {
    if (newOption !== null) {
      setOption(newOption);
    }
  };

  const handleClear = () => {
    setRate("");
    setOption("overall");
    setWeights({
      weight_lstm: 0,
      weight_bilstm: 0,
      weight_arima: 0,
      weight_sarima: 0,
      weight_iter: 0,
    });
  };


  const sortedImDatalogs = [...imdatalogs].sort((a, b) => {
    const key = Object.keys(sortConfig).find(
      (k) => sortConfig[k].direction !== "asc"
    );
    if (!key) return 0;
    const direction = sortConfig[key].direction === "asc" ? 1 : -1;
    if (a[key] < b[key]) return -1 * direction;
    if (a[key] > b[key]) return 1 * direction;
    return 0;
  });


  // const imdownloadAsCSV = () => {
  //   const csv = Papa.unparse(imdatalogs);
  //   const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  //   const fileName = `imputation_datalogs_${selectedMarker.wellId}_${selectedVersion}.csv`;
  //   saveAs(blob, fileName);
  // };

  const imdownloadAsCSV = () => {
    const options = {
      fields: ["Measurement Time", "Water Level", "Is Imputed?"], 
      quotes: true 
    };

   
    const customData = imdatalogs.map(row => [
      row.mTm,           
      row.wtr,             
      row.is_imputed ? "Yes" : "No"  
    ]);

    // Create CSV with custom field names
    const csv = Papa.unparse({
      fields: options.fields,
      data: customData
    }, options);

    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const fileName = `imputation_datalogs_${selectedMarker.wellId}_${selectedVersion}.csv`;
    saveAs(blob, fileName);
  };

  const imdownloadAsPDF = () => {
    const doc = new jsPDF();
    const tableData = imdatalogs.map((datalog) => [
      datalog.mTm,
      datalog.wtr,
      datalog.is_imputed ? "Yes" : "No",
    ]);

    doc.text("Datalogs", 14, 10);
    doc.autoTable({
      head: [
        [
          "Measurement Time",
          "Water Level",
          "Is Imputed?",
        ],
      ],
      body: tableData,
    });
    const fileName = `imputation_datalogs_of_well_${selectedMarker.wellId}_versions_${selectedVersion}.pdf`;

    doc.save(fileName);
  };

  const getImDatalogs = async (wellId) => {
    fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs_last/${wellId}`)
      .then((res) => res.json())
      .then((newImdatalogs) => {
        setimDatalogs(newImdatalogs);
        console.log(newImdatalogs);
        return newImdatalogs;
      })
      .catch((err) => console.error(err));
  };


  const chartRef = useRef();

  const handleDownload = () => {
    if (chartRef.current) {
      html2canvas(chartRef.current).then((canvas) => {
        const link = document.createElement("a");
        link.download = "ImputedDatalog.png";
        link.href = canvas.toDataURL();
        link.click();
      });
    }
  };

  const handleDoImputation = async (retryCount = 0, maxRetries = 5) => {
    if (selectedMarker) {
      setIsLoading(true); // Set loading state to true

      let url = "";

      // Check if both startDate and endDate are provided
      if (startDate && endDate) {
        // Validate date range
        if (!startDate || !endDate) {
          alert("Please select valid dates.");
          setIsLoading(false);
          return;
        }

        if (startDate > endDate) {
          alert("Start date cannot be after end date.");
          setIsLoading(false);
          return;
        }

        const formattedStartDate = startDate;
        const formattedEndDate = endDate;

        // API call with date range
        url = `https://warpo-dashboard.cse.buet.ac.bd/api/send-datalogs/${selectedMarker.wellId}/${Rate}/${option}/${weights.weight_lstm}/${weights.weight_bilstm}/${weights.weight_arima}/${weights.weight_sarima}/${weights.weight_iter}/${formattedStartDate}/${formattedEndDate}`;
      } else {
        // Fallback to the original API without date range
        url =
          weights.weight_lstm === 0 &&
            weights.weight_bilstm === 0 &&
            weights.weight_arima === 0 &&
            weights.weight_sarima === 0 &&
            weights.weight_iter === 0
            ? `https://warpo-dashboard.cse.buet.ac.bd/api/send-datalogs/${selectedMarker.wellId}/${Rate}/${option}`
            : `https://warpo-dashboard.cse.buet.ac.bd/api/send-datalogs/${selectedMarker.wellId}/${Rate}/${option}/${weights.weight_lstm}/${weights.weight_bilstm}/${weights.weight_arima}/${weights.weight_sarima}/${weights.weight_iter}`;
      }

      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${localStorage.getItem('token')}`
          }
        });
        if (!res.ok) throw new Error(`Request failed with status ${res.status}`);

        const imputedData = await res.json();
        console.log("Received imputed datalogs:", imputedData);

        // Fetch updated imputed datalogs and display
        const updatedData = await getImDatalogs(selectedMarker.wellId);

        // Fetch updated versions list to refresh the dropdown
        await fetchVersions(selectedMarker.wellId);

        // Set the latest version as selected
        // if (versions.length > 0) {
        //   setSelectedVersion(versions[versions.length - 1].version_number);
        // }

        setIsImModalOpen(true); // Open modal only if successful
      } catch (err) {
        console.error("Error during imputation:", err);
        if (retryCount < maxRetries) {
          console.warn(`Retrying... Attempt ${retryCount + 1}`);
          await handleDoImputation(retryCount + 1, maxRetries); // Ensure retries are awaited
        } else {
          console.error("Max retries reached. Aborting.");
        }
      } finally {
        setIsLoading(false); // Reset loading state once imputation is completed
      }
    }
  };




  const handleReUseImputation = async (retryCount = 0, maxRetries = 5) => {
    if (!selectedMarker) {
      alert("Please select a well marker first");
      return;
    }

    // Check if weights are all zero
    const allZeroWeights =
      weights.weight_lstm === 0 &&
      weights.weight_bilstm === 0 &&
      weights.weight_arima === 0 &&
      weights.weight_sarima === 0 &&
      weights.weight_iter === 0;

    if (allZeroWeights) {
      alert("Please set at least one model weight above zero");
      return;
    }

    setIsLoading(true); // Set loading state to true

    try {
      const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/reuse-imputation/${selectedMarker.wellId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          weights: {
            weight_lstm: weights.weight_lstm,
            weight_bilstm: weights.weight_bilstm,
            weight_arima: weights.weight_arima,
            weight_sarima: weights.weight_sarima,
            weight_iter: weights.weight_iter
          },
          start_date: startDate,
          end_date: endDate
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `Request failed with status ${response.status}`);
      }

      const result = await response.json();
      console.log("Reused imputation result:", result);

      // Fetch updated imputed datalogs and display
      const updatedData = await getImDatalogs(selectedMarker.wellId);

      // Fetch updated versions list to refresh the dropdown
      await fetchVersions(selectedMarker.wellId);

      // Set the latest version as selected
      // if (versions.length > 0) {
      //   setSelectedVersion(versions[versions.length - 1].version_number);
      // }

      // Show success message
      alert(`Successfully reused imputation: ${result.count} data points updated. Reload the page and select the latest version from the right panel to view the most recent imputed data.`);

      // Open modal only if data was successfully updated
      if (updatedData && updatedData.length > 0) {
        setIsImModalOpen(true); // Open modal to show the results
      }

      if (response.status === 404) {
        const errorData = await response.json();
        alert(errorData.error); // Show the error message as a pop-up
        return;
      }

    } catch (err) {
      console.error("Error during reuse imputation:", err);

      if (retryCount < maxRetries) {
        console.warn(`Retrying... Attempt ${retryCount + 1}`);
        setTimeout(() => {
          handleReUseImputation(retryCount + 1, maxRetries); // Retry with a slight delay
        }, 1000);
      } else {
        console.error("Max retries reached. Aborting.");
        alert(`Failed to reuse imputation: ${err.message}`);
      }
    } finally {
      setIsLoading(false); // Reset loading state once imputation is completed
    }
  };


  const [isLoading, setIsLoading] = useState(false);

  // Render loading indicator
  if (isLoading) {
    return (
      <Modal
        open={isLoading}
        onClose={() => setIsLoading(false)}
        className="loading-modal"
      >
        <div className="loading-content">
          <CircularProgress color="primary" />
          <Typography
            variant="h6"
            style={{ marginTop: "20px", color: "#333333" }}
          >
            Working, Please Wait ...
          </Typography>
          <div className="progress-bar">
            <div className="progress" style={{ width: `${progress}%` }}></div>
          </div>
        </div>
      </Modal>
    );
  }


  const handleShowImDatalog = () => {
    setIsLoading(true);
    setProgress(0);
    const duration = 5000; // Total duration in milliseconds (5 seconds)
    const intervalTime = 50; // Interval time in milliseconds
    const increment = 100 / (duration / intervalTime); // Calculate increment value

    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            getImDatalogs(selectedMarker.wellId);
            setIsImModalOpen(true);
            setIsLoading(false);
          }, 2000); // Keep the screen for an additional 1 second after progress completes
          return 100;
        }
        return prevProgress + increment;
      });
    }, intervalTime);
  };

  const handleMultiColImputation = () => {
    
    setIsImModalOpen(false);
    setIsMultiColImModalOpen(true)
            
  };


  const fetchMissingDataRate = async () => {
    if (!selectedMarker || !startDate || !endDate) {
      alert("Please specify both start and end dates");
      return;
    }

    if (startDate > endDate) {
      alert("Start date cannot be after end date");
      return;
    }

    // setIsLoading(true);

    try {
      const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/missing-data-rate/${selectedMarker.wellId}/${startDate}/${endDate}`, {
        method: "GET"
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const data = await response.json();
      console.log("Missing data rate response:", data);

      setMissingDataRate(data.missingRate);
      setShowMissingRate(true);

    } catch (error) {
      console.error("Error fetching missing data rate:", error);
      alert(`Failed to fetch missing data rate: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  // Function to close the missing rate message
  const closeMissingRateMessage = () => {
    setShowMissingRate(false);
  };

  return (
    <div className="modal">
      <div className="modal-overlay" />
      <div className="modal-row">
        <div className="modal-content left-content">
          <div className="input-group">
            <div className="left-content-wrapper" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                <div className="imputation-header" style={{marginRight: "20px"}}>
                  <h2 style={{ marginBottom: "0px", marginTop: '0px', color: "red" }}>Imputation using Groundwater Level Data</h2>
                </div>
                <div className="multiple-col-imputation">
                  <button
                    variant="contained"
                    onClick={handleMultiColImputation}
                    style={{
                      height: "60px",
                      backgroundColor: "#ff1111",
                      color: "white",
                      textTransform: "none",
                      fontSize: "20px",
                      width: "250px"
                    }}
                  >
                    Imputation using Bi-Temporal Framework
                  </button>
                </div>
              </div>
              <div className="well-info-container" style={{ marginRight: "20px" }}>
                
                <h2 style={{ marginBottom: "0px", marginTop: 0 }}>{selectedMarker.wellId}</h2>
                <p style={{ textAlign: "center", margin: "4px 0" }}>
                  <FaMapMarkerAlt style={{ marginRight: "8px", color: "red" }} /> {selectedMarker.union_}, {selectedMarker.upazilla}, {selectedMarker.district}, {selectedMarker.division}
                </p>
              </div>

                
              

              <div className="date-range-display">
                <p style={{ textAlign: "center", margin: "4px 0" }}>
                  <strong>Earliest Date:</strong> {earliestDate ? new Date(earliestDate).toLocaleDateString() : 'Loading...'} &nbsp; | &nbsp;
                  <strong>Latest Date:</strong> {latestDate ? new Date(latestDate).toLocaleDateString() : 'Loading...'}
                </p>
              </div>



              <Modal
                open={showMinDateModal}
                onClose={handleCloseMinDateModal}
                aria-labelledby="min-date-modal-title"
              >
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: 400,
                  backgroundColor: '#fff',
                  border: '2px solid #000',
                  boxShadow: 24,
                  padding: '20px 30px',
                  borderRadius: '8px'
                }}>
                  <Typography id="min-date-modal-title" variant="h6" component="h2" style={{ color: '#d32f2f', marginBottom: '15px' }}>
                    Insufficient Date Range
                  </Typography>
                  <Typography style={{ marginBottom: '20px', color: '#333' }}>
                    Please select an end date that is at least 2 years after the start date for proper imputation analysis.
                  </Typography>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      onClick={handleCloseMinDateModal}
                      variant="contained"
                      style={{ backgroundColor: '#d32f2f', color: 'white' }}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </Modal>
              <div className="date-range-container" style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "-10px" }}>
                <div className="date-inputs" style={{ display: "flex", flexDirection: "row", gap: "20px", alignItems: "flex-end" }}>
                  <div className="date-field-container">
                    <label htmlFor="start-date" style={{ color: "#85126e", marginBottom: "5px", display: "block" }}>Start Date</label>
                    <input
                      id="start-date"
                      type="date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      className="date-input-field"
                      style={{
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        color: "#85126e",
                        width: "200px"
                      }}
                    />
                  </div>
                  <div className="date-field-container">
                    <label htmlFor="end-date" style={{ color: "#85126e", marginBottom: "5px", display: "block" }}>End Date</label>
                    <input
                      id="end-date"
                      type="date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      className="date-input-field"
                      style={{
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        color: "#85126e",
                        width: "200px"
                      }}
                    />
                  </div>
                </div>

                {/* Add Missing Data Rate Button centered */}
                <div style={{ marginTop: "0px", display: "flex", justifyContent: "center" }}>
                  <Button
                    variant="contained"
                    onClick={fetchMissingDataRate}
                    style={{
                      height: "40px",
                      backgroundColor: "#4a148c",
                      color: "white",
                      textTransform: "none",
                      fontSize: "16px",
                      width: "250px"
                    }}
                  >
                    Show Missing Data Rate
                  </Button>
                </div>

                {/* Static Missing Data Rate Message */}
                {showMissingRate && missingDataRate !== null && (
                  <div
                    style={{
                      marginTop: "15px",
                      padding: "10px",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "90%",
                      textAlign: "center"
                    }}
                  >
                    <p style={{ margin: 0, fontWeight: "bold", textAlign: "center" }}>
                      Missing Data Rate for Selected Period: <span style={{ color: "#d32f2f" }}>{missingDataRate.toFixed(2)}%</span>
                    </p>
                  </div>
                )}
              </div>


              <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "10px" }}>
                <div className="missing-container">
                  <h3>Artificial Missing Rate:</h3>
                  <TextField
                    variant="outlined"
                    value={Rate}
                    onChange={handleRateChange}
                    className="rate-text-field"
                    InputLabelProps={{
                      style: { color: "#85126e" },
                    }}
                    InputProps={{
                      style: { color: "#85126e" },
                    }}
                    sx={{ height: "54px" }}
                  />
                </div>
                <div className="toggle-group-container">
                  <h3>Season-Based Type:</h3>
                  <ToggleButtonGroup
                    value={option}
                    exclusive
                    onChange={handleOption}
                    aria-label="Choose one"
                    className="toggle-button-group"
                    sx={{
                      height: "54px",
                      width: "250px",
                      display: "flex"
                    }}
                  >
                    <ToggleButton
                      value="overall"
                      aria-label="overall"
                      sx={{
                        flex: "1 1 50%",
                        borderRadius: option === "overall" ? undefined : "4px 0 0 4px"
                      }}
                    >
                      Overall
                    </ToggleButton>
                    <ToggleButton
                      value="peak"
                      aria-label="peak"
                      sx={{
                        flex: "1 1 50%",
                        borderRadius: option === "peak" ? undefined : "0 4px 4px 0"
                      }}
                    >
                      Peak - Off-Peak
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
              </div>
            </div>
          </div>

          <ModelRankingTable
            selectedMarker={selectedMarker}
            Rate={Rate}
            option={option}
            startDate={startDate}
            endDate={endDate}
            imp_or_anom="imp"
          />


          <div className="model-weights">
            <h3>Model Weights:</h3>
            <TextField
              label="LSTM"
              variant="outlined"
              name="weight_lstm"
              value={weights.weight_lstm}
              onChange={handleWeightChange}
              className="weight-input"
            />
            <TextField
              label="BiLSTM"
              variant="outlined"
              name="weight_bilstm"
              value={weights.weight_bilstm}
              onChange={handleWeightChange}
              className="weight-input"
            />
            <TextField
              label="ARIMA"
              variant="outlined"
              name="weight_arima"
              value={weights.weight_arima}
              onChange={handleWeightChange}
              className="weight-input"
            />
            <TextField
              label="SARIMA"
              variant="outlined"
              name="weight_sarima"
              value={weights.weight_sarima}
              onChange={handleWeightChange}
              className="weight-input"
            />
            <TextField
              label="Iterative"
              variant="outlined"
              name="weight_iter"
              value={weights.weight_iter}
              onChange={handleWeightChange}
              className="weight-input"
            />
          </div>



          <div className="action-buttons" style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            marginTop: "20px"
          }}>
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              width: "100%",
              border: '2px solid grey', 
              padding: "20px",
              justifyContent: "center"
            }}>
              <FormControl variant="outlined" style={{ minWidth: "200px" }}>
                <InputLabel id="imputation-type-label">Imputation Type</InputLabel>
                <Select
                  labelId="imputation-type-label"
                  value={imputationType}
                  onChange={handleImputationTypeChange}
                  label="Imputation Type"
                >
                  <MenuItem value="reuse">Reuse Data from Model Ranking</MenuItem>
                  <MenuItem value="new">New Calculation for Imputation</MenuItem>
                </Select>
              </FormControl>

              <div style={{
                marginLeft: "10px",
                maxWidth: "400px",
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                padding: "8px 12px",
                backgroundColor: "#f5f5f5",
                color: "#000000"
              }}>
                <strong>Note:</strong> Choose whether to reuse the imputed data from model ranking or run a new imputation.
              </div>
            </div>

            <Button
              variant="contained"
              onClick={handleSubmit}
              className="button submit-button"
              style={{
                height: "40px",
                width: "170px",
                textTransform: "none",
                fontSize: "16px"
              }}
            >
              Submit
            </Button>
          </div>

        </div>

        <div className="modal-content right-content" style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          height: "100vh",
          textAlign: "center",
          padding: "10px",
          gap: "5px",
        }}>
          <div style={{ flexShrink: 0 }}>
            <div className="button-group" style={{ marginBottom: '0px', marginTop: '35px' }}>
              <Button
                variant="contained"
                onClick={imdownloadAsCSV}
                className="blue-button"
                size="small"
                style={{ margin: "0 2px" }}
              >
                Download as CSV
              </Button>
              <Button
                variant="contained"
                onClick={imdownloadAsPDF}
                className="green-button"
                size="small"
                style={{ margin: "0 2px" }}
              >
                Download as PDF
              </Button>
              {/* <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => setHelpOpen(true)}
                >
                  Help
                </Button> */}
              <Button
                variant="contained"
                onClick={handleCloseImModal}
                className="red-button"
                size="small"
                style={{ margin: "0 2px" }}
              >
                Close Window
              </Button>
            </div>

            <div className="well-info-container" style={{ marginTop: "5px", marginBottom: "10px" }}>
              <h2 style={{ margin: 0, fontSize: "18px", marginTop: "10px" }}>{selectedMarker.wellId}</h2>
              <p style={{ marginBottom: '5px', fontSize: "14px", textAlign: "center" }}>
                <FaMapMarkerAlt style={{ marginRight: "8px", color: "red" }} /> {selectedMarker.union_}, {selectedMarker.upazilla}, {selectedMarker.district}, {selectedMarker.division}
              </p>
            </div>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              marginBottom: '10px',
              justifyContent: 'center'
            }}>
              <FormControl variant="outlined" style={{ width: '600px' }}>
                <InputLabel id="version-label">Select Version of Imputation</InputLabel>
                <Select
                  labelId="version-label"
                  value={selectedVersion || ''}
                  onChange={handleVersionChange}
                  label="Select Version"
                  fullWidth
                >
                  {versions.map((version) => (
                    <MenuItem key={version.version_number} value={version.version_number}>
                      {`[${version.measurement_parameters.join(', ')}] Version ${version.version_number} - ${format(new Date(version.update_time), 'dd-MM-yyyy HH:mm:ss')}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                variant="contained"
                color="primary"
                onClick={handleDetailsButtonClick}
                disabled={!selectedVersion}
              >
                Details
              </Button>
            </div>
          </div>


          <Modal open={isModalOpen} onClose={handleCloseModal}>
            <div
              style={{
                position: 'absolute',
                top: '53%',
                left: '74%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'cyan',
                color: 'black',
                padding: '20px',
                borderRadius: '8px',
                minWidth: '400px',
              }}
            >
              <Typography variant="h6">Version Details</Typography>

              {versionDetails ? (
                <div>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Well ID:</strong> {versionDetails.wellId}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Version Number:</strong> {versionDetails.version_number}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Update Time:</strong> {formatDate(versionDetails.update_time)}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}>
                    <strong>Date Range:</strong>  {formatDate(versionDetails.start_date, 'd MMM yyyy')} to{' '}
                    {formatDate(versionDetails.end_date, 'd MMM yyyy')}
                  </p>

                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Name:</strong> {versionDetails.name}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Designation:</strong> {versionDetails.designation}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Email:</strong> {versionDetails.email}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Contact No:</strong> {versionDetails.contact_no}</p>
                  <p style={{ color: 'black', fontSize: '16px' }}><strong>Comments:</strong> {versionDetails.comments}</p>
                </div>
              ) : (
                <p>Loading...</p>
              )}

              {/* Close Button */}
              <Button
                onClick={handleCloseModal}
                style={{ backgroundColor: 'red', color: 'white', width: '100px' }}
              >
                Close
              </Button>
            </div>
          </Modal>

          {/* Help Modal */}
          <HelpModal
            open={helpOpen}
            handleClose={() => setHelpOpen(false)}
          />


          <div style={{ flex: 1, overflowY: 'auto', padding: '10px', marginLeft: '10px', marginRight: '10px' }}>

            <div className="graph-container" style={{ marginBottom: '5px', width: "100%" }}>

              <div className="button-group" style={{ display: "flex", gap: "3px", justifyContent: "center", marginBottom: "5px" }}>

                <Button
                  variant="contained"
                  onClick={resetZoomImDatalogs}
                  className="zoom-button"
                  size="small"
                >
                  Reset Zoom
                </Button>
                <Button
                  variant="contained"
                  onClick={handleDownload}
                  className="zoom-button"
                  size="small"
                >
                  Save Image
                </Button>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  width: "100%",
                  marginBottom: "5px"
                }}
              >
                <Slider
                  value={zoomLevelImDatalogs}
                  onChange={handleZoomImDatalogs}
                  aria-labelledby="zoom-slider"
                  min={0}
                  max={100}
                  step={5}
                  valueLabelDisplay="auto"
                  style={{ flex: 1 }}
                  size="small"
                />
                <h3 style={{ minWidth: "40px", margin: 0, fontSize: "14px" }}>
                  {/* {zoomLevelImDatalogs}% */}
                </h3>
              </div>

              <div className="filter-container" style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "center", marginBottom: "5px" }}>
                <h3 className="filter-label">Filter Data: </h3>
                <FormControl
                  variant="outlined"
                  size="small"
                  className="filter-dropdown"
                >
                  <InputLabel>Data Points</InputLabel>
                  <Select
                    value={dataLimitImDatalogs}
                    onChange={handleDataLimitChangeImDatalogs}
                    label="Data Points"
                  >
                    <MenuItem value={10}>Last 10</MenuItem>
                    <MenuItem value={50}>Last 50</MenuItem>
                    <MenuItem value={100}>Last 100</MenuItem>
                    <MenuItem value={visibleDataImDatalogs.length}>
                      All
                    </MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div ref={chartRef}>
                <ResponsiveContainer width="100%" height={320}>
                  <LineChart
                    data={
                      filteredDataImDatalogs.length > 0
                        ? filteredDataImDatalogs
                        : []
                    }
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="mTm"
                      tickFormatter={(tick) =>
                        new Date(tick).toLocaleDateString()
                      }
                      label={{
                        value: "Measurement Time",
                        position: "insideBottom",
                        offset: 0,
                        dy: 1,
                        fontSize: 12
                      }}
                      tick={{ fontSize: 10 }}
                    />
                    <YAxis
                      domain={[0, 12]}
                      label={{
                        value: "Water Level(meter)",

                        angle: -90,
                        position: "insideLeft",
                        dy: 60,
                        fontSize: 12
                      }}
                      tick={{ fontSize: 10 }}
                    />
                    <Tooltip
                      contentStyle={{ color: "#fff" }}
                      labelFormatter={(value) =>
                        `Time: ${formatDate(value)}`
                      }
                      formatter={(value, name) => [
                        `${value}`,
                        `${name.toUpperCase()}`,
                      ]}
                    />
                    <Line
                      type="monotone"
                      dataKey={selectedMetric}
                      stroke="#000000"
                      strokeWidth={1.5}
                      dot={<CustomDot />}
                    />
                    <Brush
                      dataKey="mTm"
                      height={40}

                      stroke="#8884d8"
                      y={280}
                      tickFormatter={(tick) =>
                        new Date(tick).toLocaleString()
                      }
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>

            <p style={{ margin: '2px 0' }}>
              Click on the cell to sort it ASC <FaArrowUp /> or DESC <FaArrowDown />
            </p>


            <TableContainer
              component={Paper}
              sx={{
                backgroundColor: "#000000",
                padding: "10px",
                borderRadius: "8px",
              }}
            >
              <Table sx={{ minWidth: 650 }}>
                <TableHead sx={{ backgroundColor: "#ffffff" }}>
                  <TableRow>
                    <TableCell>
                      <TableSortLabel
                        active={sortConfig.mTm.direction !== "asc"}
                        direction={sortConfig.mTm.direction}
                        onClick={() => handleSort("mTm")}
                      >
                        Measurement Time
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={sortConfig.wtr.direction !== "asc"}
                        direction={sortConfig.wtr.direction}
                        onClick={() => handleSort("wtr")}
                      >
                        Water Level
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel>Is Imputed?</TableSortLabel>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedImDatalogs.map((datalog) => (
                    <TableRow
                      key={datalog.id}
                      sx={{
                        backgroundColor: datalog.is_imputed ? "#052d0a" : "#1a1a1a",
                        "&:nth-of-type(odd)": {
                          backgroundColor: datalog.is_imputed ? "#052d0a" : "#262626",
                        },
                      }}
                    >
                      <TableCell sx={{ color: "#ffffff" }}>
                        {formatDate(datalog.mTm)}
                      </TableCell>
                      <TableCell sx={{ color: "#ffffff" }}>
                        {datalog.wtr}
                      </TableCell>
                      <TableCell sx={{ color: "#ffffff" }}>
                        {datalog.is_imputed ? "Yes" : "No"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Imputlog;